import MuiHidden from "@material-ui/core/Hidden"

const Hidden = ({ when, ...props }: any) => (when ? <></> : <MuiHidden {...props} />)

export default Hidden
